export class reprogamCallService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    getCampaignDispositionsAndNumbers(idCampaign, callOutID) {
        const action = "GetDispositionsAndNumbers";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                campaignId: idCampaign,
                callOutID: callOutID,
                action: "CallAction",
                callAction: action
            }
            this.SingletonWebSocket.send(message);
        }
    }

    reprogramCampaignCall(camId, dispositionId, callID, dateCallBack, telephone, existingNumber, subDispositionId) {
        const action = "Disposition";
        let time = 0;
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const messageDispose = {
                client: "integration",
                CamId: camId,
                DispositionId: dispositionId,
                CallID: callID,
                DateDial: dateCallBack,
                TelReprograma: telephone,
                existingNumber: existingNumber,
                SubId: subDispositionId,
                action: "Disposition",
                subaction: "reprogramCall"
            };
            if(this.SingletonSharedData.getCurrentStatus() === "Dialog" && dispositionId && camId && callID && !!(dateCallBack) && (existingNumber?existingNumber:!isNaN(telephone))){
                time = 500;
                const messageOpen = {
                    client: "integration",
                    action: "OpenWindow",
                    window: "Disposition"
                };
                this.SingletonWebSocket.send(messageOpen);
            }
            setTimeout(() => { this.SingletonWebSocket.send(messageDispose); }, time);
        }
    }

    CallBackAcd(idCampaign, idDisposition, callID, dateCallBack, telephone, callKey, data1, data2, data3, data4, data5, existNum, subDis) {
        const callAction = "Disposition";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), callAction)) {
            const message = {
                client: "integration",
                CamId: idCampaign,
                DispositionId: idDisposition,
                CallID: callID,
                DateDial: dateCallBack,
                TelReprograma: telephone,
                existingNumber: existNum,
                SubId: subDis,
                action: "Disposition",
                subaction: "reprogramCall"
            };
            this.SingletonWebSocket.send(message);
        }
    }
    getPhoneNumbers(callOutID) {
        const callAction = "getPhoneNumbers";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), callAction)) {
            const message = {
                client: "integration",
                callAction: callAction,
                callOutID: callOutID,
                action: "CallAction",
            };
            this.SingletonWebSocket.send(message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/reprogamCallService.js